// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const AiApiSpec_dEPRECATEDNoteGenReqBodySchema = z.object({
  timely_user_id: z.number().describe("The ID of the timely user."),
  timely_account_id: z.number().describe("The ID of the timely account."),
  tic_user_id: z.coerce.string().describe("The ID of the tic user."),
  since: z.string().datetime({ offset: true }).describe("The start time in UTC."),
  to: z.string().datetime({ offset: true }).describe("The end time in UTC."),
  style: z.optional(z.enum(["all", "with_reference", "without_reference"]).describe("The style of the note. can be one of with_reference, without_reference, and all")),
  hour: z.optional(z.object({
    id: z.optional(z.number().describe("The ID of the hour, if saved.")),
    project_id: z.optional(z.number().describe("The ID of the project, if chosen.")),
    label_ids: z.optional(z.array(z.number()).describe("The IDs of the labels, if selected.")),
    timestamps: z.optional(z.array(z.object({
      from: z.string().datetime({ offset: true }).describe("The start time of the timestamp in UTC."),
      to: z.string().datetime({ offset: true }).describe("The end time of the timestamp in UTC."),
      entry_ids: z.optional(z.array(z.coerce.string()).describe("The IDs of memories, can be either tic_group_{id}, tic_{id}, or timely_{id}")),
    })).describe("Time Entry.")),
  })),
});
